<template>
  <div>
    <div
      class="navbar"
      @mouseleave="hideMenu"
      :class="lastScrollTop > 0 ? 'black' : ''"
      v-show="showMenu && name !== '/pdfViewer'"
    >
      <div class="flexcenter">
        <img src="@/assets/img/logo.png" alt="" @click="goIndex" />
        <div class="menu-box">
          <div class="menus">
            <div
              class="menuItem"
              v-for="(item, index) in menuItems"
              :key="index"  
              @mouseover="showMenuFun(item)"
            >
              <span @click="goUrl(item)" :class="!item.subItems ? 'sub' : ''">
                {{ item.title }}
              </span>
              <i
                :class="
                  item.showMenu ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
                "
                v-if="item.subItems"
              ></i>
              <transition name="el-fade-in-linear">
                <div class="mask" v-show="item.showMenu"></div>
              </transition>
              <transition name="el-fade-in">
                <div
                  class="children-container"
                  v-show="item.showMenu"
                  @mouseleave="hideMenu(item)"
                >
                  <div class="children">
                    <div
                      class="child"
                      v-for="(item2, index2) in item.subItems"
                      :key="index2"
                    >
                      <span @click="goUrl(item2)">{{ item2.title }}</span>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
  name: "Menu",
  props: {},
  data() {
    return {
      activeIndex: "",
      menuItems: [
        { index: "/", title: "首页" },
      ],
      showMenu: true,
      lastScrollTop: 0,
      name: this.$route.path,
    };
  },
  methods: {

//获取菜单数据
getMenuData() {
  // 只定义项目案例菜单的初始配置
  const projectCaseMenu = {
    index: "4",
    title: "项目案例",
    subItems: [
      {
        title: "预建设",
        url: "", // 初始为空，后续由API填充
      },
    ]
  };

  this.$api.selectMenu({type:0}).then((res) => {
    if (res && Array.isArray(res)) {
      console.log(res,"菜单数据");
      // 处理接口返回的菜单数据
      const dynamicMenuItems = res.map(item => {
        // 为项目案例菜单保留原有处理逻辑
        if (item.menuAdd === "4") {
          // 使用预定义的项目案例菜单配置
          projectCaseMenu.title = item.menuName; // 更新标题，保留原有子项
          
          // 如果API返回了子菜单，可以更新子菜单的标题
          if (item.children && item.children.length > 0) {
            projectCaseMenu.subItems[0].title = item.children[0].menuName;
          }
          
          return projectCaseMenu;
        }
        
        // 其他菜单项的处理保持不变
        const menuItem = {
          index: item.menuAdd,
          title: item.menuName,
          type: item.type
        };
        
        // 如果有子菜单
        if (item.hasChildren && item.children && item.children.length > 0) {
          menuItem.subItems = item.children.map(child => {
            const subItem = {
              index: child.menuAdd,
              title: child.menuName,
              type: child.type
            };
            
            // 根据type设置不同的跳转方式
            switch (child.type) {
              case "0": // 链接
                subItem.url = child.menuAdd; 
                break;
              case "1": // 路由
                subItem.index = child.menuAdd; 
                break;
              case "2": // iframe
              case "3": // 图片
                subItem.url = child.menuAdd;
                break;
              case "4": // 一级菜单
                subItem.index = child.menuAdd;
                break;
              default:
                subItem.index = child.menuAdd;
            }
            
            return subItem;
          });
        }
        
        return menuItem;
      });
      
      // 首页保持在第一位
      this.menuItems = [
        { index: "/", title: "首页" },
        ...dynamicMenuItems.filter(item => item.index !== "/") 
      ];
      
      console.log("菜单数据已更新:", this.menuItems);
      
      // 获取预建设链接
      this.$api.selectLink({
        type: "2",
      })
      .then((linkRes) => {
        // 找到项目案例菜单
        const projectMenu = this.menuItems.find(item => item.index === "4");
        if (projectMenu && projectMenu.subItems && projectMenu.subItems[0]) {
          projectMenu.subItems[0].url = linkRes[0]?.link;
          console.log("预建设链接已更新:", linkRes[0]?.link);
        }
      })
      .catch(error => {
        console.error("获取链接失败:", error);
      });
    }
  }).catch(error => {
    console.error("获取菜单数据失败:", error);
  });
},




    showMenuFun(item) {
      this.menuItems.forEach((i) => {
        this.$set(i, "showMenu", false);
      });
      this.$set(item, "showMenu", true);
    },
    hideMenu() {
      this.menuItems.forEach((i) => {
        this.$set(i, "showMenu", false);
      });
    },

goUrl(item) {
  if (!item.subItems) {
    this.hideMenu();
    
    // 根据type属性决定跳转方式
    if (item.type === "0") {
  // 外部链接
  window.open(item.url, "_blank");  // 使用 url 而非 index
} else if (item.type === "1") {
      // 路由
      if (item.redirectUrl) {
        // 如果有redirectUrl属性(兼容旧数据)
        const url = this.$router.resolve({
          path: item.redirectUrl,
        });
        window.open(url.href, "_blank");
      } else if (item.index && item.index !== this.$route.path) {
        // 普通路由导航
        this.$router.push(item.index);
      } else if (item.index) {
        // 已在当前页面，刷新
        location.reload();
      }
    } else if (item.type === "2") {
      // iframe类型
      window.open(item.index, "_blank");
    } else if (item.type === "3") {
      // 图片类型
      window.open(item.index, "_blank");
    } else if (item.type === "4") {
      // 一级菜单
      if (item.index && item.index !== this.$route.path) {
        this.$router.push(item.index);
      } else if (item.index) {
        location.reload();
      }
    } else if (item.url) {
      // 兼容旧数据结构，有url属性就打开
      window.open(item.url, "_blank");
    } else if (item.index && item.index !== this.$route.path) {
      // 兜底：有index且不是当前页
      this.$router.push(item.index);
    } else if (item.index) {
      // 兜底：有index但是当前页
      location.reload();
    } else {
      // 无法处理的情况
      this.$message({
        showClose: true,
        message: "功能开发中，敬请期待",
      });
    }
  }
},
    goIndex() {
      if (this.$route.path != "/") {
        this.$router.push("/");
      }
    },
  },
  mounted() {
    this.getMenuData();
    this.$api
      .selectLink({
        type: "2",
      })
      .then((res) => {
        if (this.menuItems[3] && this.menuItems[3].subItems && this.menuItems[3].subItems[0]) {
        this.menuItems[3].subItems[0].url = res[0]?.link;
      }
      });
    let lastScrollTop = 0;
    window.addEventListener("scroll", () => {
      let currentScrollTop = document.documentElement.scrollTop;
      if (currentScrollTop > lastScrollTop) {
        this.showMenu = false;
      }
      // 如果当前滚动位置小于前一次滚动位置，说明是向上滚动
      else if (currentScrollTop < lastScrollTop) {
        this.showMenu = true;
      }
      // 如果两次滚动位置相等，则不输出

      // 更新为当前滚动位置，以便下次比较
      lastScrollTop = currentScrollTop;
      this.lastScrollTop = lastScrollTop;
    });
  },
};
</script>

<style scoped lang="less">
.navbar {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  overflow: visible;
  line-height: 100%;
  z-index: 500 !important;
  height: 80px;
  // background: linear-gradient(180deg, #000, #d9d9d900);
  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 4.6875vw;
    top: 0;
    left: 0;
    opacity: 0.25;
    height: 80px;
    background: linear-gradient(180deg, #000, #d9d9d900);
  }
  // opacity: 0.25;
  .flexcenter {
    position: relative;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 85%;
    margin: 0 auto;
    z-index: 2;
    img {
      display: block;
      width: 107px;
      height: 41px;
      cursor: pointer;
    }
  }
}

.black {
  background: #000;
}

.menus {
  position: relative;
  margin-left: 20px;
  // transition: all 2s ease;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 0;
  .menuItem {
    // height: 18px;
    margin-right: 30px;
    padding: 0 0 0 40px;
    display: flex;
    align-items: center;
    justify-items: center;
    position: relative;
    &:last-child {
      margin-right: 0;
      border-left: 1px solid #fff;
    }
    span {
      display: inline-block;
      font-size: 18px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
      white-space: nowrap;
      cursor: pointer;
    }
    .sub {
      &:hover {
        color: #009ade;
      }
    }
    i {
      margin: 0 0 0 20px;
    }
    .children-container {
      position: absolute;
      z-index: 999;
      top: 200%;
      left: 0;
      transition: all 0.5s ease;
      padding: 0 0 0 60px;
      .child {
        // font-size: 18px;
        // font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        // font-weight: 400;
        // text-align: left;
        // color: #ffffff;
        line-height: 38px;
        margin: 0 0 10px;
        span {
          &:hover {
            color: #009ade;
          }
        }
      }
    }
    .mask {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: -1;
      background: rgba(0, 0, 0, 0.7);
      pointer-events: none;
      transition: all 0.5s ease;
    }
  }
}

::v-deep .el-menu-demo {
  display: flex;
  align-items: center;
  background: none;
  margin: 20px 0;
  .el-menu-item {
    height: auto;
    line-height: 18px;
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    background: none;
    padding: 0 50px 0 30px;
    &:last-child {
      border-left: 1px solid #fff;
    }
  }
  .el-submenu__title {
    font-size: 18px !important;
    border-bottom: none !important;
  }
}

::v-deep .el-menu.el-menu--horizontal {
  border-bottom: none;
}

::v-deep .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
  color: #fff;
}

::v-deep .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: none;
  color: #fff;
}

::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #fff !important;
}

::v-deep .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: inherit !important;
}

::v-deep .el-submenu__title:focus,
.el-submenu__title:hover {
  background: inherit !important;
}

::v-deep .el-submenu__title i {
  color: #fff;
}

::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: linear-gradient(180deg, #000, rgba(0, 0, 0, 0.01)) !important;
}
</style>
